export enum OnboardingRoutePathsEnum {
  ONBOARDING = '/onboarding',
  ONBOARDING_EDIT = '/onboarding-edit',
}
